import type { Editor } from '@tiptap/react';

export interface ActiveFormats {
  bold: boolean;
  italic: boolean;
  underline: boolean;
  strike: boolean;
  code: boolean;
  highlight: boolean;
  highlightColor: string | null;
  link: boolean;
  subscript: boolean;
  superscript: boolean;
  color: string | null;
  blockType: 'paragraph' | 'h1' | 'h2' | 'h3' | 'quote' | 'bulletList' | 'orderedList' | 'codeBlock';
}

export function computeActiveFormats(editor: Editor): ActiveFormats {
  const blockType: ActiveFormats['blockType'] =
    editor.isActive('heading', { level: 1 })
      ? 'h1'
      : editor.isActive('heading', { level: 2 })
        ? 'h2'
        : editor.isActive('heading', { level: 3 })
          ? 'h3'
          : editor.isActive('blockquote')
            ? 'quote'
            : editor.isActive('bulletList')
              ? 'bulletList'
              : editor.isActive('orderedList')
                ? 'orderedList'
                : editor.isActive('codeBlock')
                  ? 'codeBlock'
                  : 'paragraph';

  const textStyleAttrs = editor.getAttributes('textStyle') as { color?: string };
  const highlightAttrs = editor.getAttributes('highlight') as { color?: string };

  return {
    bold: editor.isActive('bold'),
    italic: editor.isActive('italic'),
    underline: editor.isActive('underline'),
    strike: editor.isActive('strike'),
    code: editor.isActive('code'),
    highlight: editor.isActive('highlight'),
    highlightColor: highlightAttrs.color ?? null,
    link: editor.isActive('link'),
    subscript: editor.isActive('subscript'),
    superscript: editor.isActive('superscript'),
    color: textStyleAttrs.color ?? null,
    blockType,
  };
}
